import { render, staticRenderFns } from "./resetPasswordPage.vue?vue&type=template&id=a32ae250&scoped=true&lang=pug&"
import script from "./resetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./resetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./resetPasswordPage.vue?vue&type=style&index=0&id=a32ae250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32ae250",
  null
  
)

export default component.exports